import React, { useState } from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { TravelerProfile } from '@marageti/z4-sdk/lib/people';
import { useParams, useNavigate } from 'react-router-dom';
import TripReviewGiftFormView from './trip-review-gift-form-view';
import { useAuthStore } from '../../store';

const TripReviewGiftFormContainer = () => {
  const [submissionError, setSubmissionError] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    loggedInTraveler,
  } = useAuthStore();
  const apiClient = useApiClient();
  const travelerProfile = useFetch<TravelerProfile>(apiClient.peopleClient.getTravelerProfile, [loggedInTraveler?.id], !!loggedInTraveler?.id);
  const { reviewId } = useParams();

  const onSubmit = async (values: any) => {
    setSubmissionError(false);
    try {
      if (loggedInTraveler && loggedInTraveler?.id && reviewId) {
        // Update traveler profile
        await apiClient.peopleClient.putTravelerProfile(loggedInTraveler.id, {
          id: loggedInTraveler?.id,
          address: {
            street1: values.street1,
            street2: values.street2,
            country: values.country,
            city: values.city,
            state: values.state,
            zipcode: values.zipcode,
          },
          notes: '',
        });
        travelerProfile.mutate();

        // Update review with rewardRequested if it hasn't been requested yet.
        const dateNow = new Date().toISOString();
        const review = await apiClient.reviewsClient.getReview(reviewId);
        if (!review.rewardRequested) {
          await apiClient.reviewsClient.putReviewRewards(reviewId, {
            id: reviewId,
            rewardRequested: dateNow,
          });
        }
        navigate('../../submit', { relative: 'path' });
      }
    } catch (error: any) {
      setSubmissionError(true);
    }
  };

  const onCancel = () => {
    navigate(-1);
  };

  const isLoading = travelerProfile.isLoading || !loggedInTraveler?.id;
  const isError = !!travelerProfile.error;

  return (
    <TripReviewGiftFormView
      isLoading={isLoading}
      isError={isError}
      formProps={{
        defaultValues: {
          street1: travelerProfile?.data?.address?.street1,
          street2: travelerProfile?.data?.address?.street2,
          country: travelerProfile?.data?.address?.country,
          state: travelerProfile?.data?.address?.state,
          city: travelerProfile?.data?.address?.city,
          zipcode: travelerProfile?.data?.address?.zipcode,
        },
        onSubmit,
        onCancel,
        submissionError,
      }}
    />
  );
};

export default TripReviewGiftFormContainer;
